import React from "react";
import "./LoadingIndicator.css";

export default function LoadingIndicator() {
  return (
    <div className="loadingio-spinner-radio-o59g2j1lgy">
      <div className="ldio-an0876s6psu">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
